import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export function CountBadge({
  count,
  names,
  size = 'sm'
}) {
  const dimension = size === 'xs' ? '24px' : '32px';
  const borderColor = size === 'xs' ? 'border-core-default' : 'border-tertiary-default';
  const badge = /*#__PURE__*/_jsx(Flex, {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    inlineSize: dimension,
    blockSize: dimension,
    borderRadius: "full",
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: borderColor,
    backgroundColor: "fill-surface-default",
    marginInlineStart: "-100",
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      children: count
    })
  });
  if (!names || names.length === 0) return badge;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: names.join(', '),
    placement: "top",
    children: badge
  });
}